
<script>

import List from '@/components/ListDefault'


export default {
  name: "ListCISAccounts",

  components: {
    List,
  },

  created() {



  },

  data () {
    return {
      search: '',
      formview: 'FormCISAccount',
      table: 'cis_user',
    }
  },


  computed: {
    headers () {
      return [
        { text: 'Kunde', value: 'company' },
       // { text: 'Kunde Nr', value: 'customer_id' },
        { text: 'Beschreibung', value: 'note'},
        { text: 'E-Mail', value: 'email' },
        { text: 'Passwort', value: 'password' },
        { text: 'Typ', value: 'type' },
        { text: 'Letzter Login', value: 'last_login' },
        { text: '', value: 'edit' },
      ]
    },
  },


  methods: {



  },


}
</script>

<style scoped>

</style>


<template>
  <div>

    <List
        v-bind:headers="headers"
        v-bind:formview="formview"
        v-bind:table="table"
        v-bind:default_limit="'1000'"
        v-bind:default_sort="'email'"
        v-bind:default_sort_typ="'ASC'"
        v-bind:extension="''"
        v-bind:export_csv="false"

    ></List>

  </div>
</template>

<style scoped>

</style>